import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { routes } from '../../../constants/routes'

const mapStateToProps = (state) => {
    return {
        commissions: state.commissions
    }
}

const ListCommissions = (props) => {
    return (
        <div>
            <h1>Commissions</h1>
            <Link to={routes.commissionsCreate}>+ Create Commission</Link>
        </div>
    )
}

export default connect(mapStateToProps)(ListCommissions)
